module.exports = __webpack_public_path__ + "img/youngcompass.83d59cc5.png";